// src/constants/wfRejectReasons.js
//
// The wf_reject_reason vocabulary and its labels, in ONE place.
//
// These lived as a local const inside VerdictBar, which was fine while the bar
// was the only thing that named a reject reason. RecordFacts now shows the
// reason on a decided record, and a second copy of a value list is how
// REM-249's "one value, two homes" happens again — five instances of it were
// found in a single week. The order is the keyboard order the bar assigns, so
// it belongs to the data rather than to either component.
//
// Matches aiprime.wf_reject_reason exactly (checked 2026-09-08):
//   no_well_present, colocated_other_registry_record, cross_epoch_class_change,
//   detection_conflict, duplicate_detection, other

export const WF_REJECT_REASONS = [
  ["no_well_present", "No well present — false positive"],
  ["colocated_other_registry_record", "Colocated with another registry record"],
  ["cross_epoch_class_change", "Class changed between epochs"],
  ["detection_conflict", "Conflicts with another detection"],
  ["duplicate_detection", "Duplicate detection"],
  ["other", "Other"],
];

export const WF_REJECT_REASON_LABEL = Object.fromEntries(WF_REJECT_REASONS);
